import template from './ticketPersonalLoan.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    personalLoan: '<',
    lenders: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, helperService, TicketPersonalLoanPurpose) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.contacts = [];
      ctrl.currentOrganization = null;
      ctrl.currentCurrency = null;
      ctrl.organizationCountry = '';
      ctrl.availableTicketPersonalLoanPurposes = [];
      ctrl.availableTermInYears = [];
      ctrl.searchTerm = '';
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availableTicketPersonalLoanPurposes = TicketPersonalLoanPurpose.available();
        ctrl.availableTermInYears = helperService.getAvailableTermInYears({ isRegular: true });
        ctrl.personalLoan = ctrl.personalLoan || {};
        ctrl.lenders = ctrl.lenders || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.clearSearchTerm = () => {
        ctrl.searchTerm = '';
      };

      ctrl.isLenderSelected = (lender) => {
        if (lender && ctrl.lenders.length) {
          const lS = ctrl.lenders.find((l) => l.abbr.toLowerCase() === lender);
          return lS !== undefined;
        }
        return true;
      };

      /*
       * Save ticket personal loan
       * --------------------------------------------------------------------------------
       */
      ctrl.saveTicketPersonalLoan = () => ctrl.onFinished({ personalLoan: ctrl.personalLoan });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
